import { UseFormReturn } from "react-hook-form";
import { ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";

import TextEditor from "../Global/Editors/TextEditor";
import { useGlobalData } from "../GlobalDataProvider";
import { DTOBuilding } from "../../types/building";
import { Button, Card, Table } from "react-bootstrap";
import WizardModuleTable, { WizardModuleTableStyles } from "./WizardModuleTable";

interface IProps {
  building: DTOBuilding;
  formHook: UseFormReturn;
  onAddModule: (mt: ModuleTypeId) => void;
  onRemoveModule: (mId: Number) => void;
}

const WizardPage4 = ({ building, formHook, onAddModule, onRemoveModule }: IProps) => {
  const globalData = useGlobalData();

  let moduleTypes = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.Kyla);
  const modules = building.modules.filter((m) => moduleTypes.find((mt) => mt.id === m.moduleTypeId));

  if (modules.length > 0 && modules.find((m) => m.moduleTypeId === ModuleTypeId.KylaSaknas) === undefined) {
    moduleTypes = moduleTypes.filter((mt) => mt.id !== ModuleTypeId.KylaSaknas);
  }

  return (
    <>
      <Card.Title className="pt-4">Kylsystem</Card.Title>
      <WizardModuleTable
        modules={modules}
        moduleTypes={moduleTypes}
        tableStyle={WizardModuleTableStyles.Normal}
        onRemoveModule={onRemoveModule}
        onAddModule={onAddModule}
        formHook={formHook}
      />
    </>
  );
};

export default WizardPage4;
